import * as React from "react";
import {
	AppBar,
	Box,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Paper,
} from "@material-ui/core";
import librariesJson from "./assets/libraries.json";
import { Either } from "tsmonad";
import JsonousDecoder, * as jsonous from "jsonous";
import * as decoding from "@src/persistence/decoding";

// Styles
import { useAboutStyles } from "./styles";

export { AboutArea };

interface Library {
	name: string;
	license: string;
	link: string;
}

interface AboutAreaProps {
	version: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function decodeLibraries(item: any): Either<string, Library[]> {
	const decoder: JsonousDecoder<Library[]> = jsonous.array(
		jsonous.field("name", jsonous.string).andThen((name: string) =>
			jsonous.field("license", jsonous.string).andThen((license: string) =>
				jsonous.field("link", jsonous.string).andThen((link: string) =>
					jsonous.succeed({
						name,
						license,
						link,
					})
				)
			)
		)
	);
	return decoding.applyJsonousDecoder(
		decoder,
		{
			failure: (error: string): string => `Could not decode library: ${error}`,
			success: (decodedResult: Library[]): Library[] => decodedResult,
		},
		item
	);
}

function AboutArea({ version }: AboutAreaProps): JSX.Element {
	const classes = useAboutStyles();

	const eitherLibraries = decodeLibraries(librariesJson);

	return (
		<Box className={classes.aboutContainer}>
			<AppBar className={classes.appbar} position="static">
				<Typography className={classes.title}>About</Typography>
			</AppBar>
			<Box className={classes.copyright}>
				<Typography className={classes.text}>
					MIIMETIQ® version {version}
				</Typography>
				<Typography className={classes.text}>
					Copyright© NEXIONA CONNECTOCRATS SL. All rights reserved
				</Typography>
				<Typography className={classes.text}>
					MIIMETIQ® is made possible by Open Source Software
				</Typography>
			</Box>
			<Paper className={classes.paperContainer}>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							<TableCell className={classes.tableHeader}>Library</TableCell>
							<TableCell className={classes.tableHeader}>License</TableCell>
							<TableCell className={classes.tableHeader}>Link</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{eitherLibraries.caseOf({
							left: () => null,
							right: (libraries) =>
								libraries.map((library) => {
									return (
										<TableRow key={library.name}>
											<TableCell>{library.name}</TableCell>
											<TableCell>{library.license}</TableCell>
											<TableCell>
												<a href={library.link} rel="noreferrer" target="_blank">
													{library.link}
												</a>
											</TableCell>
										</TableRow>
									);
								}),
						})}
					</TableBody>
				</Table>
			</Paper>
		</Box>
	);
}
